import './category_list.scss'
import React from "react";
import {useStateContext} from "../../helpers/state-context.js";
import {getCategoryById} from "./categories_mapping.js";
import {ModelConsumer} from "../../helpers/model/model-consumer.js";
import {ModelCountriesMain} from "../../models/country.js";
import {CountryList} from '../country-list.js';
import {Analytics} from '../../helpers/analytics';

function CategoryList(props) {
    const [state, dispatch] = useStateContext(['categories', 'selectedCategory']);
    const category = getCategoryById(state.selectedCategory)

    if (state.selectedCategory && state.categories && state.categories.includes(state.selectedCategory)) {
        return <ModelConsumer model={ModelCountriesMain}>

            {(resultSet) => {
                return <CountryList description={category.long_description}
                        countries={resultSet.data.values
                                ?.filter((item) => (
                                    item.categories.some((e) => (state.categories.includes(e))) &&
                                            item.country_name
                                ))
                                ?.sort((a, b)=>a?.country_name?.localeCompare(b.country_name))}
                        showCountryLink={!state.categories.includes(8)}
                        onCountrySelect={(country)=>{
                            Analytics.trackEvent({
                                action: 'select country',
                                category: 'country list',
                                label: country.country_name
                            });
                            dispatch({type: 'page', value: 'country'});
                            dispatch({type: 'country', value: country.country_code});
                        }}
                        onClose={()=>{
                            dispatch({type: 'selectedCategory', value: null});
                            dispatch({type: 'setDefaultCategories'})
                        }}/>
            }}
        </ModelConsumer>
    }
    return <></>
}

CategoryList.defaultProps = {
    data: [
        'Algeria',
        'Kenya',
        'Country name',
        'Country name',
        'Country name',
        'Country name',
        'Country name',
        'Country name'
    ]
};

export {CategoryList}